import React from "react";
import PropTypes, { ValidationMap } from "prop-types";

export function enhanceContext<T extends PropTypes.ValidationMap<any>>(contextTypes: T) {
    return function <P>(Component: React.ComponentClass<P>) {
        return class EnhancedComponent extends Component {
            static contextTypes = {
                ...Component.contextTypes,
                ...contextTypes,
            };
        };
    };
}

export const withLegacyContext = function <T extends Record<string, any>>(context: T) {
    const contextTypes = (Object.keys(context) as Array<keyof T>).reduce((types, key) => {
        types[key] = getPropType(context[key]);
        return types;
    }, {} as ValidationMap<T>);

    return function <P>(Component: React.ComponentType<P>): React.ComponentClass<P> {
        return class LegacyContextProvider extends React.Component<P> {
            static contextTypes = contextTypes;
            static childContextTypes = contextTypes;
            static propTypes = Component.propTypes;

            getChildContext() {
                // noinspection JSDeprecatedSymbols
                return {
                    ...(this.context || {}),
                    ...context,
                };
            }

            render() {
                return <Component {...this.props} />;
            }
        };
    };
};

function getPropType<T>(value: T) {
    switch (typeof value) {
        case "boolean":
            return PropTypes.bool;
        case "number":
            return PropTypes.number;
        case "string":
            return PropTypes.string;
        case "function":
            return PropTypes.func;
        case "object":
            if (value) {
                return Array.isArray(value) ? PropTypes.array : PropTypes.object;
            }
            break;
    }
    return PropTypes.any;
}
